import React, { useCallback } from 'react';
import './App.css';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

function App() {
    const track = useCallback((name, props = {}) => {
        // Cloudflare Web Analytics custom events via _cfq queue
        // https://developers.cloudflare.com/analytics/web-analytics/
        try {
            window._cfq = window._cfq || [];
            window._cfq.push([
                'track',
                name,
                props
            ]);
        } catch (e) {
            // no-op
        }
    }, []);


    return (
        <div className="App">
            <div className="container">
                <img
                    src="/profilepic.jpeg"
                    alt="Lucas Kiefer"
                    className="profile-photo"
                    loading="eager"
                    decoding="async"
                    referrerPolicy="no-referrer"
                    width={192}
                    height={192}
                />
                <h1 className="heading">Hi, I'm Lucas Kiefer</h1>

                <p className="description">
                    I'm the <strong>founder of a new company</strong> based in SF.
                    Before that, I spent four years at <strong>Recurrency</strong>, starting as a software engineer
                    and then <strong>leading the creation of the demand planning and
                    purchasing product</strong> as a product manager. I took it from <strong>0 → scaling</strong>, growing it into a platform
                    managing <strong>billions in inventory</strong> and <strong>hundreds of millions of dollars</strong> in purchases every year.
                    I graduated from <strong>Georgia Tech</strong> with a degree in <strong>Computer Science</strong>,
                    concentrating in artificial intelligence and theory.
                </p>



                <p className="contact">
                    Reach out! Email me at <a href="mailto:lucas@lucaskiefer.com" className="contact-link" onClick={() => track('Email Clicked', { method: 'email' })}>lucas@lucaskiefer.com</a>
                </p>

                <div className="social-icons">
                    <a href="https://linkedin.com/in/lucaskiefer" target="_blank" rel="noopener noreferrer" className="icon-link" onClick={() => track('LinkedIn Clicked', { url: 'https://linkedin.com/in/lucaskiefer' })}>
                        <FaLinkedin className="icon" />
                    </a>
                    <a href="https://github.com/lucaskiefer" target="_blank" rel="noopener noreferrer" className="icon-link" onClick={() => track('GitHub Clicked', { url: 'https://github.com/lucaskiefer' })}>
                        <FaGithub className="icon" />
                    </a>
                </div>


            </div>
        </div>
    );
}

export default App;
